import React, { useEffect, useState} from "react";
import './wbs2iframe-sync.css';
import html2canvas from "html2canvas";
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import PrintButton from './PrintButton'; 
import html2pdf from 'html2pdf.js';
import { showToast } from './toastUtils';
import Swal from 'sweetalert2';
import FullscreenLoader from './FullscreenLoader';
import { queuedApiFetch, apiFetch } from './api';
// import domtoimage from "dom-to-image-more";

function Wbs2iframesync() {

    const [wbsColumns, setWbsColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [addedItems, setAddedItems] = useState([]);
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';  
    const getUserAccess = userDetails ? userDetails.access_level : ''; 
    const userId = userDetails ? userDetails.id : '';
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    const projectid = selectedProjectDetail.projectNumber;
    const projectName = selectedProjectDetail.projectName;
    const [WBSTableLoading, setWBSTableLoading] = useState(true);
    const [WBSEditTableLoading, setWBSEditTableLoading] = useState(true);
    const [exportLoading, setExportLoading] = useState(false);
    const [csvexportLoading, setcsvExportLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [tableOneExportData, setTableOneExportData] = useState([]);
    const [userCompany, setUserCompany] = useState();
    const [proj_access_level, setProjAccessLevel] = useState(false);
    const getUserCompanyDetails =userCompany;


    const widthDescription = document.getElementById('description-wbs');
    const widthContract = document.getElementById('contract-wbs');
    const widthConversion = widthContract?.offsetWidth + widthDescription?.offsetWidth;
    // console.log({widthConversion})

    const getUserEmail = localStorage.getItem('userEmail');
        const [userPermission, setUserPermission] = useState();
        const [userRoleManual, setUserRolesManual] = useState();
  // console.log('userId', userId);
  // console.log('ProjectNumber', projectid);
  // console.log('userRoleManual', userRoleManual);
  // console.log('userPermission', userPermission);
  // console.log('userCompanyName', getUserCompanyDetails);
     const fetchData = async () => {
              try {
                  await fetchUserCompany();
                  await fetchUserRole();
              } catch (error) {
                  console.error("Error fetching data:", error);
              }
          };
          
          useEffect(() => {
              fetchData();
          }, []);
      
          const fetchUserRole = async () => {
            if (!userId || !projectid) {
              return;
            }
            const requestOptions = {
              method: 'GET',
              //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
            };
             try {
              const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${projectid}`, requestOptions);
              const data = await response;
          
              if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
              // console.log(data.data); 
              setUserRolesManual(data.data);
              setProjAccessLevel(data.access_level);
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            } finally {
              setLoading(false); // End loading
            }
          }
      
          const fetchUserCompany = async () => {
            const requestOptions = {
              method: 'GET',
              //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
            };
             try {
              const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
              const data = await response;
          
              if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
                setUserCompany(data.data.company_name);
                setUserPermission(data.data.access_level);     
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            } finally {
              // setLoading(false); // End loading
            }
          }
    

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('en-US', { 
        style:'currency', 
        currency: 'USD', 
        currencyDisplay: 'symbol' // This will display the currency code (USD) instead of the symbol.
      }).format(amount);
    };

    // const fetchWBSData = () => {
    //     setWBSTableLoading(true);
    //     const requestOptions = {
    //         method: "GET",
    //         // redirect: "follow",
    //         //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    //     };

    //     fetch(process.env.REACT_APP_BACKEND_URL+"/funding/getwbs?projectid="+projectid, requestOptions)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             if(data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success'){
    //                 const wbsCodes = [...new Set(data.data.map((item) => item.WBS_ID))];
    //                 setWbsColumns(wbsCodes);

    //                 const formattedRows = [
    //                     {
    //                         description: "BUC No.",
    //                         data: data.data
    //                             .filter((item) => item.DESCRIPTION === "BUC No.")
    //                             .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
    //                         total: data.data
    //                             .filter((item) => item.DESCRIPTION === "BUC No.")
    //                             .reduce((acc, item) => acc + item.WBS_VALUE, 0),
    //                     },
    //                     {
    //                         description: "Fund Code.",
    //                         data: data.data
    //                             .filter((item) => item.DESCRIPTION === "Fund Code.")
    //                             .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
    //                         total: data.data
    //                             .filter((item) => item.DESCRIPTION === "Fund Code.")
    //                             .reduce((acc, item) => acc + item.WBS_VALUE, 0),
    //                     },
    //                     {
    //                         description: "Approved Budget",
    //                         data: data.data
    //                             .filter((item) => item.DESCRIPTION === "Approved Budget")
    //                             .map((item) => ({ id: item.ID, value: parseFloat(item.WBS_VALUE) })),
    //                         total: data.data
    //                             .filter((item) => item.DESCRIPTION === "Approved Budget")
    //                             .reduce((acc, item) => parseFloat(acc) + parseFloat(item.WBS_VALUE), 0),
    //                     },
    //                 ];

    //                 setRows(formattedRows);
    //             }
    //         })
    //         .catch((error) => console.error("Error fetching data:", error))
    //         .finally(()=> setWBSTableLoading(false))
    // };

    const fetchWBSData = async () => {
        setWBSTableLoading(true);
      
        const requestOptions = {
          method: "GET",
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
        };
      
        try {
          const response = await queuedApiFetch(`/funding/getwbs?projectid=${projectid}`,
            requestOptions
          );
      
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
            const wbsCodes = [...new Set(data.data.map((item) => item.WBS_ID))];
            setWbsColumns(wbsCodes);
      
            const formattedRows = [
              {
                description: "BUC No.",
                data: data.data
                  .filter((item) => item.DESCRIPTION === "BUC No.")
                  .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
                total: data.data
                  .filter((item) => item.DESCRIPTION === "BUC No.")
                  .reduce((acc, item) => acc + item.WBS_VALUE, 0),
              },
              {
                description: "Fund Code.",
                data: data.data
                  .filter((item) => item.DESCRIPTION === "Fund Code.")
                  .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
                total: data.data
                  .filter((item) => item.DESCRIPTION === "Fund Code.")
                  .reduce((acc, item) => acc + item.WBS_VALUE, 0),
              },
              {
                description: "Approved Budget",
                data: data.data
                  .filter((item) => item.DESCRIPTION === "Approved Budget")
                  .map((item) => ({ id: item.ID, value: parseFloat(item.WBS_VALUE) })),
                total: data.data
                  .filter((item) => item.DESCRIPTION === "Approved Budget")
                  .reduce((acc, item) => parseFloat(acc) + parseFloat(item.WBS_VALUE), 0),
              },
            ];            
            setRows(formattedRows);
            const exportData = await  convertFormattedRowsToExportData(formattedRows, projectid, projectName,wbsCodes);
            setTableOneExportData(exportData);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setWBSTableLoading(false);
        }
      };

      const convertFormattedRowsToExportData = (formattedRows, projectid, projectName, wbsCodes) => {
        let wbsIndex = 0; // Initialize index for wbsCodes
      
        return formattedRows
        .filter((row) => row.description !== "BUC No." && row.description !== "Fund Code.") // Exclude specific descriptions
        .flatMap((row) =>
          row.data.map((dataItem) => {
            const budgetName = wbsCodes[wbsIndex % wbsCodes.length]; // Assign WBS code sequentially
            wbsIndex++; // Increment index for the next iteration
            return {
              project_id: projectid,
              Project_name: projectName,
              Budget_Code: budgetName,
              Budget_group_name: '',
              budget_Name: budgetName, // Dynamically assign WBS code
              Qty: 1,
              Unit: 1,
              Unit_Cost: dataItem.value,
              Amount: '',
              Input_Qty: '',
              Scope: '',
              Budget_Flag: '',
              Budget_Id: '',
              Segment: 2,
            };
          })
        );
      };
            
      
    // const fetchEditWBSData = () => {
    //     setWBSEditTableLoading(true);
    //     const requestOptions = {
    //         method: "GET",
    //         //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    //     };
      
    //     fetch(process.env.REACT_APP_BACKEND_URL+"/funding/getwbsgroup?projectid="+projectid, requestOptions)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             if(data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success'){
    //                 const transformedData = transformWBSData(data.data);
    //                 setAddedItems((prevItems) => {
    //                     const updatedItems = prevItems.map(existingItem => {
    //                         // Find if the group exists in the new transformed data
    //                         const newItem = transformedData.find(
    //                             newItem => newItem.group === existingItem.group
    //                         );
        
    //                         // If a matching new item is found, compare the wbsValues
    //                         if (newItem) {
    //                             const wbsValuesMatch = JSON.stringify(existingItem.descriptions.map(desc => desc.wbsValues)) === JSON.stringify(newItem.descriptions.map(desc => desc.wbsValues));
                                
    //                             // If wbsValues do not match, update the existing item with newItem's wbsValues
    //                             if (!wbsValuesMatch) {
    //                                 return {
    //                                     ...existingItem,
    //                                     descriptions: newItem.descriptions // Update the descriptions (which include wbsValues)
    //                                 };
    //                             }
    //                         }
    //                         return existingItem; // If no changes, return the original item
    //                     });
        
    //                     // Add new items that weren't in the previous list
    //                     const newItems = transformedData.filter(
    //                         newItem => !prevItems.some(
    //                             existingItem => existingItem.group === newItem.group
    //                         )
    //                     );
        
    //                     return [...updatedItems, ...newItems]; // Return updated and newly added items
    //                 });
    //             }
    //         })
    //         .catch((error) => console.error("Error fetching data:", error))
    //         .finally(()=> setWBSEditTableLoading(false));
    //   };

    const fetchEditWBSData = async () => {
        setWBSEditTableLoading(true);
      
        const requestOptions = {
          method: "GET",
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
        };
      
        try {
          const response = await queuedApiFetch(`/funding/getwbsgroup?projectid=${projectid}`,
            requestOptions
          );
      
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
            const transformedData = transformWBSData(data.data);
      
            setAddedItems((prevItems) => {
              const updatedItems = prevItems.map((existingItem) => {
                // Find if the group exists in the new transformed data
                const newItem = transformedData.find(
                  (newItem) => newItem.group === existingItem.group
                );
      
                // If a matching new item is found, compare the wbsValues
                if (newItem) {
                  const wbsValuesMatch =
                    JSON.stringify(existingItem.descriptions.map((desc) => desc.wbsValues)) ===
                    JSON.stringify(newItem.descriptions.map((desc) => desc.wbsValues));
      
                  // If wbsValues do not match, update the existing item with newItem's wbsValues
                  if (!wbsValuesMatch) {
                    return {
                      ...existingItem,
                      descriptions: newItem.descriptions, // Update the descriptions (which include wbsValues)
                    };
                  }
                }
                return existingItem; // If no changes, return the original item
              });
      
              // Add new items that weren't in the previous list
              const newItems = transformedData.filter(
                (newItem) =>
                  !prevItems.some((existingItem) => existingItem.group === newItem.group)
              );
      
              //return [...updatedItems, ...newItems]; // Return updated and newly added items
              const combinedItems = [...updatedItems, ...newItems];
            
              // Remove items where descriptions[0].description is null or empty
              return combinedItems.filter(
                (item) =>
                  item.descriptions.length > 0 &&
                  item.descriptions[0].description !== null &&
                  item.descriptions[0].description !== ""
              );
            });
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setWBSEditTableLoading(false);
        }
      };
      
      // const transformWBSData = (data) => {
      //   const groups = {};
    
      //   data.forEach((item) => {
      //     const { P_grp_desc, P_grp_item_desc, P_grp_id, P_grp_item_id, P_grp_wbs_id, P_grp_wbs_value } = item;
    
      //     // If the group does not exist, initialize it with group information
      //     if (!groups[P_grp_id]) {
      //       groups[P_grp_id] = {
      //         group: P_grp_desc,
      //         groupId: P_grp_id, // Include P_grp_id as groupId
      //         descriptions: []
      //       };
      //     }
    
      //     // Check if the description already exists for the group
      //     const descriptionIndex = groups[P_grp_id].descriptions.findIndex(
      //       (desc) => desc.description === P_grp_item_desc
      //     );
    
      //     if (descriptionIndex === -1) {
      //       // If the description doesn't exist, add it with the itemId
      //       groups[P_grp_id].descriptions.push({
      //         description: P_grp_item_desc,
      //         itemId: P_grp_item_id, // Include P_grp_item_id as itemId
      //         wbsValues: { [P_grp_wbs_id]: P_grp_wbs_value }
      //       });
      //     } else {
      //       // If the description exists, update the WBS values
      //       groups[P_grp_id].descriptions[descriptionIndex].wbsValues[P_grp_wbs_id] = P_grp_wbs_value;
      //     }
      //   });    
      //   // Convert the groups object into an array of group objects with descriptions array
      //   return Object.values(groups);
      // };



      const transformWBSData = (rawData) => {
        const groupMap = {};
      
        rawData.forEach((item) => {

          if (item.P_grp_id === 1 && item.P_grp_item_id === 3) return; 
          
          const groupId = item.P_grp_id;
      
          if (!groupMap[groupId]) {
            groupMap[groupId] = {
              groupId: groupId,
              group: item.P_grp_desc,
              descriptions: [],
            };
          }
      
          // Find or add the description
          let description = groupMap[groupId].descriptions.find(
            (d) => d.description === item.P_grp_item_desc
          );
      
          if (!description) {
            description = {
              description: item.P_grp_item_desc,
              itemId: item.P_grp_item_id, 
              wbsValues: {},
            };
            groupMap[groupId].descriptions.push(description);
          }
      
          // Set WBS value
          description.wbsValues[item.P_grp_wbs_id] = item.P_grp_wbs_value;
        });
      
        Object.values(groupMap).forEach(group => {
          group.descriptions.sort((a, b) => a.itemId - b.itemId);
        });
      
        // Convert map to array
        const groupsArray = Object.values(groupMap);

        const priorityStart = [1, 2, 3];
        const priorityEnd = [4, 5];
      
        groupsArray.sort((a, b) => {
          const aId = a.groupId;
          const bId = b.groupId;
      
          const aInStart = priorityStart.indexOf(aId);
          const bInStart = priorityStart.indexOf(bId);
      
          const aInEnd = priorityEnd.indexOf(aId);
          const bInEnd = priorityEnd.indexOf(bId);
      
          if (aInStart !== -1 && bInStart !== -1) return aInStart - bInStart;
          if (aInStart !== -1) return -1;
          if (bInStart !== -1) return 1;
      
          if (aInEnd !== -1 && bInEnd !== -1) return aInEnd - bInEnd;
          if (aInEnd !== -1) return 1;
          if (bInEnd !== -1) return -1;
      
          return aId - bId;
        });
      
        return groupsArray;
      };
      
      


    useEffect(() => {
        fetchWBSData();
        fetchEditWBSData()
    }, []);

    // const generateWBSReference = (index) => {
    //     const base = "D-A80"; // Base part of WBS Reference
    //     const middle = (index + 1).toString().padStart(3, '0'); // Middle part (XXX), padded to 3 digits
    //     const end = "000"; // Ending part (YYY-ZZZ)
    //     return `${base}-${middle}-${end}`;
    // };

    // const generateWBSReference = (index, projectName, budgetGroupName) => {
    //     // Generate WBS Prefix (e.g., WBS1, WBS2, etc.)
    //     const wbsPrefix = `WBS${index % 2 === 0 ? 2 : 1}`;
        
    //     // Replace spaces in projectName and budgetGroupName with underscores
    //     const formattedProjectName = projectName.replace(/ /g, '_');
    //     const formattedBudgetGroupName = budgetGroupName.replace(/ /g, '_');
        
    //     // Generate WBS Code (e.g., WBS1_Main_Contract_Sum_01)
    //     const budgetNumber = String(index).padStart(2, '0'); // Zero-padded index
    //     return `${wbsPrefix}_${formattedBudgetGroupName}_${budgetNumber}`;
    // };

    const budgetGroupNumbers = {}; // Object to track budget numbers for each budget group

const generateWBSReference = (wbsCode, projectName, budgetGroupName) => {
    // Generate WBS Prefix: Alternate between WBS1 and WBS2 based on `isSecondWBS`
    const wbsPrefix = wbsCode;
    
    // Replace spaces with underscores in projectName and budgetGroupName
    const formattedProjectName = projectName.replace(/ /g, '_');
    const formattedBudgetGroupName = budgetGroupName.replace(/ /g, '_');
    
    // Ensure each budget group has a consistent number
    if (!budgetGroupNumbers[formattedBudgetGroupName]) {
        budgetGroupNumbers[formattedBudgetGroupName] = Object.keys(budgetGroupNumbers).length + 1; // Increment counter
    }
    const budgetNumber = String(budgetGroupNumbers[formattedBudgetGroupName]).padStart(2, '0'); // Zero-padded number
    
    // Generate the final Budget Code
    return `${wbsPrefix}_${formattedBudgetGroupName}_${budgetNumber}`;
};

//Excel Export
  // const tableRef = useRef();

  // const exportToExcel = () => {
  //   const table = tableRef.current;

  //   // Convert HTML table to worksheet
  //   const ws = XLSX.utils.table_to_sheet(table);

  //   // Create workbook
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   // Write file
  //   const excelBuffer = XLSX.write(wb, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const data = new Blob([excelBuffer], {
  //     type:
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(data, "report.xlsx");
  // };

  // const handleExport = async () => {
  //   const element = document.getElementById("export-section");

  //   if (!element) {
  //     alert("Export section not found");
  //     return;
  //   }

  //   // Capture full styled UI
  //   const canvas = await html2canvas(element, {
  //     scale: 3,              // 🔥 improves quality
  //     useCORS: true,
  //     backgroundColor: "#ffffff"
  //   });

  //   const imgData = canvas.toDataURL("image/png");

  //   // Create workbook
  //   const wb = XLSX.utils.book_new();
  //   const ws = XLSX.utils.aoa_to_sheet([[]]);

  //   // 🔥 Add image manually (SheetJS workaround)
  //   ws["!images"] = [
  //     {
  //       name: "StyledExport",
  //       data: imgData,
  //       opts: { base64: true },
  //       position: {
  //         type: "twoCellAnchor",
  //         from: { col: 0, row: 0 },
  //         to: { col: 10, row: 30 }
  //       }
  //     }
  //   ];

  //   XLSX.utils.book_append_sheet(wb, ws, "Report");

  //   XLSX.writeFile(wb, "Styled_Report.xlsx");
  // };

  //html to excel without any calculation
  const handleExport1 = async () => {

    const content = document.getElementById("export-section").outerHTML;

    const html = `
      <html>
        <head>
          <meta charset="UTF-8">
        </head>
        <body>
          ${content}
        </body>
      </html>
    `;

    const blob = new Blob([html], {
      type: "application/vnd.ms-excel",
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "Styled_Report.xls"; // ⚠️ use .xls
    a.click();

    URL.revokeObjectURL(url);




  

  };

  const handleExport2 = async () => {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Report");

  let currentRow = 1;

  // =========================
  // ✅ TABLE 1 (WBS TABLE)
  // =========================

  const header1 = ["WBS No", ...wbsColumns, "Total"];
  const headerRow = ws.addRow(header1);

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF003d7c" },
    };
    cell.alignment = { horizontal: "center" };
    cell.border = { top: {style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
  });

  rows.forEach((row, rowIndex) => {
    const rowData = [
      row.description,
      ...row.data.map(d => d.value),
      rowIndex < 2 ? "" : row.total
    ];

    const excelRow = ws.addRow(rowData);

    excelRow.eachCell(cell => {
      cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
    });
  });

  ws.addRow([]);
  ws.addRow([]);

  // =========================
  // ✅ TABLE 2 (COST TABLE)
  // =========================

  const header2 = ["Description", "", "Contract Sum", ...wbsColumns, "Total"];
  const headerRow2 = ws.addRow(header2);

  headerRow2.eachCell(cell => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF003d7c" },
    };
    cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
  });

  // Merge "Description" columns
  ws.mergeCells(`A${headerRow2.number}:B${headerRow2.number}`);

  addedItems.forEach(group => {

    // ===== Group Row =====
    const groupRow = ws.addRow([
      group.group,
      "",
      "",
      ...wbsColumns.map(wbsId =>
        group.descriptions.reduce((acc, d) =>
          acc + parseFloat(d.wbsValues?.[wbsId] || 0), 0)
      ),
      ""
    ]);

    ws.mergeCells(`A${groupRow.number}:B${groupRow.number}`);

    groupRow.eachCell(cell => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE6F0FF" },
      };
      cell.font = { bold: true };
      cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
    });

    // ===== Description Rows =====
    group.descriptions.forEach((desc, i) => {
      const rowTotal = Object.values(desc.wbsValues || {})
        .reduce((a, b) => a + parseFloat(b), 0);

      const r = ws.addRow([
        i + 1,
        desc.description,
        "from LOA",
        ...wbsColumns.map(w => desc.wbsValues?.[w] || 0),
        rowTotal
      ]);

      r.eachCell(cell => {
        cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
      });
    });

  });



  // =========================
// ✅ FOOTER SECTION
// =========================

// Helper: get column total
const getColumnTotal = (columnIndex) => {
  return addedItems.reduce((groupAcc, group) => {
    return groupAcc + group.descriptions.reduce((descAcc, desc) => {
      return descAcc + parseFloat(desc.wbsValues?.[wbsColumns[columnIndex]] || 0);
    }, 0);
  }, 0);
};

// Helper: approved budget from table1
const getApprovedBudget = (columnIndex) => {
  return rows.reduce((acc, row) => {
    const val = row.data[columnIndex]?.value;
    return !isNaN(val) ? parseFloat(val) : acc;
  }, 0);
};

// Common style
const applyFooterStyle = (row) => {
  row.eachCell(cell => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE6F0FF" },
    };
    cell.font = { bold: true };
    cell.border = {
      top:{style:'thin'}, left:{style:'thin'},
      bottom:{style:'thin'}, right:{style:'thin'}
    };
  });
};

// =========================
// ✅ GST ROW
// =========================
const gstRowValues = ["GST (on all items above excluding GST Adjustments, if any)", "", ""];

let gstTotal = 0;

wbsColumns.forEach((_, i) => {
  const total = getColumnTotal(i);
  const gst = total * 0.09;
  gstTotal += gst;
  gstRowValues.push(gst);
});

gstRowValues.push(gstTotal);

const gstRow = ws.addRow(gstRowValues);
ws.mergeCells(`A${gstRow.number}:B${gstRow.number}`);
applyFooterStyle(gstRow);

// =========================
// ✅ TOTAL PROJECT COST
// =========================
const totalRowValues = ["Total Project Cost", "", ""];

let grandTotal = 0;

wbsColumns.forEach((_, i) => {
  const total = getColumnTotal(i);
  const gst = total * 0.09;
  const final = total + gst;
  grandTotal += final;
  totalRowValues.push(final);
});

totalRowValues.push(grandTotal);

const totalRow = ws.addRow(totalRowValues);
ws.mergeCells(`A${totalRow.number}:B${totalRow.number}`);
applyFooterStyle(totalRow);

// =========================
// ✅ TYPE 1 SAVINGS
// =========================
const savingsRowValues = ["Type 1 Savings (to declare for savings of $50k and above)", "", ""];

let totalSavings = 0;

wbsColumns.forEach((_, i) => {
  const approved = getApprovedBudget(i);
  const total = getColumnTotal(i);
  const gst = total * 0.09;
  const cost = total + gst;

  const savings = approved - cost;
  totalSavings += isNaN(savings) ? 0 : savings;

  savingsRowValues.push(isNaN(savings) ? 0 : savings);
});

savingsRowValues.push(totalSavings);

const savingsRow = ws.addRow(savingsRowValues);
ws.mergeCells(`A${savingsRow.number}:B${savingsRow.number}`);
applyFooterStyle(savingsRow);

// =========================
// ✅ INTERIM TYPE 3
// =========================
const interimRowValues = ["Interim Type 3", "", ""];

wbsColumns.forEach(() => interimRowValues.push(0));
interimRowValues.push(0);

const interimRow = ws.addRow(interimRowValues);
ws.mergeCells(`A${interimRow.number}:B${interimRow.number}`);
applyFooterStyle(interimRow);





  // =========================
  // ✅ AUTO WIDTH
  // =========================
  ws.columns.forEach(col => {
    col.width = 18;
  });

  // =========================
  // ✅ EXPORT
  // =========================
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "WBS_Report.xlsx");
};

//html to excel with calculation
const handleExport = async () => {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Sync to ACC");

  // =========================
  // COMMON STYLE HELPERS
  // =========================
  const borderStyle = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  const applyHeaderStyle = (row, color = "FF003d7c") => {
    row.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: color } };
      cell.alignment = { horizontal: "center" };
      cell.border = borderStyle;
    });
  };

  const applyBorder = (row) => {
    row.eachCell((cell) => {
      cell.border = borderStyle;
    });
  };

  const applyFooterStyle = (row) => {
    row.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6F0FF" } };
      cell.border = borderStyle;
    });
  };

  // =========================
  // TABLE 1 (WBS TABLE)
  // =========================
  const header1 = ["WBS No", ...wbsColumns, "Total"];
  const headerRow1 = ws.addRow(header1);
  applyHeaderStyle(headerRow1);

  rows.forEach((row, rowIndex) => {
    const rowData = [
      row.description,
      ...row.data.map((d) => d.value),
      rowIndex < 2 ? "" : row.total,
    ];

    const r = ws.addRow(rowData);
    applyBorder(r);
  });

  ws.addRow([]);
  ws.addRow([]);

  // =========================
  // TABLE 2 (COST TABLE)
  // =========================
  const header2 = ["Description", "", "Contract Sum", ...wbsColumns, "Total"];
  const headerRow2 = ws.addRow(header2);
  applyHeaderStyle(headerRow2, "FF003d7c");

  ws.mergeCells(`A${headerRow2.number}:B${headerRow2.number}`);

  // =========================
  // DATA ROWS
  // =========================
  addedItems.forEach((group) => {
    // ===== Column totals =====
    const columnTotals = wbsColumns.map((wbsId) =>
      group.descriptions.reduce(
        (acc, desc) => acc + parseFloat(desc.wbsValues?.[wbsId] || 0),
        0
      )
    );

    // ===== Group total =====
    const groupTotalValue = group.descriptions.reduce((groupAcc, desc) => {
      const rowTotal = Object.values(desc.wbsValues || {}).reduce(
        (rowAcc, val) => rowAcc + parseFloat(val || 0),
        0
      );
      return groupAcc + rowTotal;
    }, 0);

    // ===== GROUP ROW =====
    const groupRow = ws.addRow([
      group.group,
      "",
      "",
      ...columnTotals,
      groupTotalValue,
    ]);

    ws.mergeCells(`A${groupRow.number}:B${groupRow.number}`);

    groupRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6F0FF" } };
      cell.border = borderStyle;
    });

    // ===== DESCRIPTION ROWS =====
    group.descriptions.forEach((desc, i) => {
      const rowTotal = Object.values(desc.wbsValues || {}).reduce(
        (acc, val) => acc + parseFloat(val || 0),
        0
      );

      const r = ws.addRow([
        i + 1,
        desc.description,
        "from LOA",
        ...wbsColumns.map((w) => desc.wbsValues?.[w] || 0),
        rowTotal,
      ]);

      applyBorder(r);
    });
  });

  // =========================
  // FOOTER CALCULATIONS
  // =========================

  const getColumnTotal = (columnIndex) => {
    return addedItems.reduce((groupAcc, group) => {
      return groupAcc + group.descriptions.reduce((descAcc, desc) => {
        return descAcc + parseFloat(desc.wbsValues?.[wbsColumns[columnIndex]] || 0);
      }, 0);
    }, 0);
  };

  const getApprovedBudget = (columnIndex) => {
    return rows.reduce((acc, row) => {
      const val = row.data[columnIndex]?.value;
      return !isNaN(val) ? parseFloat(val) : acc;
    }, 0);
  };

  // ===== GST =====
  let gstTotal = 0;
  const gstRowValues = ["GST (on all items above excluding GST Adjustments, if any)", "", ""];

  wbsColumns.forEach((_, i) => {
    const total = getColumnTotal(i);
    const gst = total * 0.09;
    gstTotal += gst;
    gstRowValues.push(gst);
  });

  gstRowValues.push(gstTotal);

  const gstRow = ws.addRow(gstRowValues);
  ws.mergeCells(`A${gstRow.number}:B${gstRow.number}`);
  applyFooterStyle(gstRow);

  // ===== TOTAL PROJECT COST =====
  let grandTotal = 0;
  const totalRowValues = ["Total Project Cost", "", ""];

  wbsColumns.forEach((_, i) => {
    const total = getColumnTotal(i);
    const gst = total * 0.09;
    const final = total + gst;
    grandTotal += final;
    totalRowValues.push(final);
  });

  totalRowValues.push(grandTotal);

  const totalRow = ws.addRow(totalRowValues);
  ws.mergeCells(`A${totalRow.number}:B${totalRow.number}`);
  applyFooterStyle(totalRow);

  // ===== TYPE 1 SAVINGS =====
  let totalSavings = 0;
  const savingsRowValues = ["Type 1 Savings (to declare for savings of $50k and above)", "", ""];

  wbsColumns.forEach((_, i) => {
    const approved = getApprovedBudget(i);
    const total = getColumnTotal(i);
    const gst = total * 0.09;
    const cost = total + gst;

    const savings = approved - cost;
    totalSavings += isNaN(savings) ? 0 : savings;

    savingsRowValues.push(isNaN(savings) ? 0 : savings);
  });

  savingsRowValues.push(totalSavings);

  const savingsRow = ws.addRow(savingsRowValues);
  ws.mergeCells(`A${savingsRow.number}:B${savingsRow.number}`);
  applyFooterStyle(savingsRow);

  // ===== INTERIM TYPE 3 =====
  const interimRowValues = ["Interim Type 3", "", ""];

  wbsColumns.forEach(() => interimRowValues.push(0));
  interimRowValues.push(0);

  const interimRow = ws.addRow(interimRowValues);
  ws.mergeCells(`A${interimRow.number}:B${interimRow.number}`);
  applyFooterStyle(interimRow);

  // =========================
  // COLUMN WIDTH
  // =========================
  ws.columns.forEach((col) => {
    col.width = 18;
  });

  // =========================
  // EXPORT
  // =========================
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Synctoacc_Report.xlsx");
};


//for csv export
const exportData = async (exportType = 'xlsx') => {
  try {
      setcsvExportLoading(true);

      Swal.fire({
          html: 'Please wait while we process your request...',
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading(); // Show the loader
          },
      });

      // Define headers for CSV and XLSX export
      const headers = [
          "Budget Code",
          "Budget Group Name",
          "Name",
          "Qty",
          "Unit",
          "Unit Cost",
          "Amount",
          "Input Qty",
          "Scope"
      ];

      let exportContent = [];

      // Add headers to exportContent (array)
      exportContent.push(headers);

      let wbsCounter = 1;
      const exportData = []; // Array to hold data for POST API

      // Add data rows and build exportData array
      addedItems.forEach((group) => {
          group.descriptions.forEach((descriptionObj) => {
              Object.entries(descriptionObj.wbsValues).forEach(([wbsCode, value]) => {
                  const rowData = [
                      wbsCode, // WBS Reference
                      descriptionObj.description,        // Description
                      `${wbsCode} ${descriptionObj.description}`, // WBS Code and Description
                      1, 1, value, '', '', ''            // Other values
                  ];

                  // Add to the exportContent array (CSV or XLSX)
                  exportContent.push(rowData); // For CSV export

                  exportData.push({
                      project_id: projectid,
                      Project_name: projectName,
                      Budget_Code: wbsCode,
                      Budget_group_name: descriptionObj.description,
                      budget_Name: `${wbsCode} ${descriptionObj.description}`,
                      Qty: 1,
                      Unit: 1,
                      Unit_Cost: value,
                      Amount: '',
                      Input_Qty: '',
                      Scope: '',
                      Budget_Flag: '',
                      Budget_Id: '',
                      Segment: 1
                  });
              });
          });
      });

      const mergedData = exportData.concat(tableOneExportData);

      if (exportType === 'csv') {
          // Create CSV string
          let csvContent = "data:text/csv;charset=utf-8,";

          exportContent.forEach((rowArray) => {
              const row = rowArray.join(",");
              csvContent += row + "\r\n"; // Add line break after each row
          });

          // Create a download link and trigger the download
          const encodedUri = encodeURI(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "exported_data.csv");
          document.body.appendChild(link); // Append link to DOM
          link.click(); // Trigger download
      } else {
          // For XLSX export
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Export Data');
          
          // Add headers and data to the XLSX worksheet
          exportContent.forEach((row, index) => {
              worksheet.addRow(row);
          });

          // Export workbook to file
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, 'exported_data.xlsx');
      }

  } catch (error) {
      console.error('Export error:', error);
      showToast.error('An error occurred during export');
  } finally {
      setcsvExportLoading(false);
      Swal.close();
  }
};

  const exportToXLS = async () => {
    try {
      //setExportLoading(true);

      // Swal.fire({
      //   // title: 'Loading...',
      //   html: 'Please wait while we process your request...',
      //   allowOutsideClick: false, // Prevent closing the popup by clicking outside
      //   didOpen: () => {
      //     Swal.showLoading(); // Show the loader
      //   },
      // });

      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Empty Template 2 segm 1 Level');

      // Define headers
      const headers = [
        "Budget Code",
        "Budget Group Name",
        "Name",
        "Qty",
        "Unit",
        "Unit Cost",
        "Amount",
        "Input Qty",
        "Scope"
      ];

      // Add headers to worksheet
      worksheet.addRow(headers);

      // Apply header styles
      headers.forEach((header, index) => {
        const cell = worksheet.getCell(`${String.fromCharCode(65 + index)}1`);

        // Set background colors for "Budget Code" and ""
        if (header === "Budget Code" || header === "") {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'E2F0D9' },
          };
        } else {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF2CC' },  // Default yellow background for others
          };
        }

        // Set text color to orange for "Amount", "Input Qty", and "Scope"
        if (header === "Amount" || header === "Input Qty" || header === "Scope") {
          cell.font = {
            bold: true,
            color: { argb: 'ED7D31' },  // Orange text color
          };
        } else {
          cell.font = { bold: true, color: { argb: '0070C0' } };  // Default bold font for others
        }

        // Set alignment for all headers
        cell.alignment = { horizontal: 'center' };
      });

      let wbsCounter = 1;
      const exportData = []; // Array to hold data for POST API

      // Add data rows and build exportData array
      addedItems.forEach((group) => {
        group.descriptions.forEach((descriptionObj) => {
          Object.entries(descriptionObj.wbsValues).forEach(([wbsCode, value]) => {
            const rowData = [
              //generateWBSReference(wbsCode, projectName, descriptionObj.description), // WBS Reference
              wbsCode, // WBS Reference
              descriptionObj.description,        // Description
              `${wbsCode} ${descriptionObj.description}`, // WBS Code and Description
              1, 1, value, '', '', ''            // Other values
            ];

            worksheet.addRow(rowData); // Add row to the worksheet
            exportData.push({
              project_id: projectid,
              Project_name: projectName,
              Budget_Code: wbsCode,// Budget_Code: generateWBSReference(wbsCode, projectName, descriptionObj.description),
              Budget_group_name: descriptionObj.description,
              budget_Name: `${wbsCode} ${descriptionObj.description}`,
              Qty: 1,
              Unit: 1,
              Unit_Cost: value,
              Amount: '',
              Input_Qty: '',
              Scope: '',
              Budget_Flag: '',
              Budget_Id: '',
              Segment: 1
            });
          });
        });
      });

      const mergedData = exportData.concat(tableOneExportData);
      // Export workbook to file
      // const buffer = await workbook.xlsx.writeBuffer();
      // const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // saveAs(blob, 'FlexibleCodeBudgets.xlsx');

      // Send data to POST API
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
        body: JSON.stringify(mergedData),
      };

      //Swal.fire("Info", "Budget sync in progress. Please check later.", "info");
      showToast.info("Budget sync in progress. CPMS will send email after completion.");

      const response = await queuedApiFetch(`/funding/insertbudget`, requestOptions);
      const result = await response;

       // Backend immediately returns 202
    // if (result.apistatus.Status_Code === 202) {
    //   showToast.info("Budget sync in progress. CPMS will send email after completion.");
    // } else {
    //   showToast.error(result.apistatus.Status_Description || "Budget sync failed.");
    // }

      if (result.apistatus.Status_Code === 200) {
        //showToast.success(result.apistatus.Status_Description);
        console.log(result.apistatus.Status_Description);
        if (result.email_sts == false) {
          //Swal.fire("Info", "No emails found for this project. No Email sent !", "info");
          console.log("No emails found for this project. No Email sent !");
        }
      }
    } catch (error) {
      console.error('Budget Sync error:', error);
      showToast.error("An error occurred while starting budget sync.");
      //showToast.error('An error occurred during export');
    } finally {
      setExportLoading(false);
      Swal.close();
    }
  };

  const exportToXLS_Old = async () => {
    try {
      setExportLoading(true);

      Swal.fire({
        // title: 'Loading...',
        html: 'Please wait while we process your request...',
        allowOutsideClick: false, // Prevent closing the popup by clicking outside
        didOpen: () => {
          Swal.showLoading(); // Show the loader
        },
      });

      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Empty Template 2 segm 1 Level');

      // Define headers
      const headers = [
        "Budget Code",
        "Budget Group Name",
        "Name",
        "Qty",
        "Unit",
        "Unit Cost",
        "Amount",
        "Input Qty",
        "Scope"
      ];

      // Add headers to worksheet
      worksheet.addRow(headers);

      // Apply header styles
      headers.forEach((header, index) => {
        const cell = worksheet.getCell(`${String.fromCharCode(65 + index)}1`);

        // Set background colors for "Budget Code" and ""
        if (header === "Budget Code" || header === "") {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'E2F0D9' },
          };
        } else {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF2CC' },  // Default yellow background for others
          };
        }

        // Set text color to orange for "Amount", "Input Qty", and "Scope"
        if (header === "Amount" || header === "Input Qty" || header === "Scope") {
          cell.font = {
            bold: true,
            color: { argb: 'ED7D31' },  // Orange text color
          };
        } else {
          cell.font = { bold: true, color: { argb: '0070C0' } };  // Default bold font for others
        }

        // Set alignment for all headers
        cell.alignment = { horizontal: 'center' };
      });

      let wbsCounter = 1;
      const exportData = []; // Array to hold data for POST API

      // Add data rows and build exportData array
      addedItems.forEach((group) => {
        group.descriptions.forEach((descriptionObj) => {
          Object.entries(descriptionObj.wbsValues).forEach(([wbsCode, value]) => {
            const rowData = [
              //generateWBSReference(wbsCode, projectName, descriptionObj.description), // WBS Reference
              wbsCode, // WBS Reference
              descriptionObj.description,        // Description
              `${wbsCode} ${descriptionObj.description}`, // WBS Code and Description
              1, 1, value, '', '', ''            // Other values
            ];

            worksheet.addRow(rowData); // Add row to the worksheet
            exportData.push({
              project_id: projectid,
              Project_name: projectName,
              Budget_Code: wbsCode,// Budget_Code: generateWBSReference(wbsCode, projectName, descriptionObj.description),
              Budget_group_name: descriptionObj.description,
              budget_Name: `${wbsCode} ${descriptionObj.description}`,
              Qty: 1,
              Unit: 1,
              Unit_Cost: value,
              Amount: '',
              Input_Qty: '',
              Scope: '',
              Budget_Flag: '',
              Budget_Id: '',
              Segment: 1
            });
          });
        });
      });

      const mergedData = exportData.concat(tableOneExportData);
      // Export workbook to file
      // const buffer = await workbook.xlsx.writeBuffer();
      // const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // saveAs(blob, 'FlexibleCodeBudgets.xlsx');

      // Send data to POST API
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
        body: JSON.stringify(mergedData),
      };

      const response = await queuedApiFetch(`/funding/insertbudget`, requestOptions);
      const result = await response;

      if (result.apistatus.Status_Code === 200) {
        showToast.success(result.apistatus.Status_Description);
        if (result.email_sts == false) {
          Swal.fire("Info", "No emails found for this project. No Email sent !", "info");
        }
      }
    } catch (error) {
      console.error('Export error:', error);
      showToast.error('An error occurred during export');
    } finally {
      setExportLoading(false);
      Swal.close();
    }
  };

  const formatAsCurrency = (value) => {
    // Ensure the value is treated as a string and clean it
    let numericValue = String(value).replace(/[^0-9.]/g, '');

    // If empty or invalid number, return empty string
    if (!numericValue || isNaN(numericValue)) return '';

    // Parse to a float number to handle decimal cases
    const number = parseFloat(numericValue);

    // Format the number as USD currency, without forcing decimal places
    let formattedValue = number.toLocaleString('en-US');

    // Return the formatted number, no currency symbol as the '$' is already in the span
    return formattedValue;
  };

  //     const btn_sts = (
  //   expectedCompany,
  //   projectAdminRoles = []
  // ) => {
  //   var sts = (
  //     //   (
  //     // (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
  //     // (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
  //     // (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin & Contract (AC)')
  //     // // (userRoleManual === 'Admin & Contract (AC)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
  //     // )

  //     (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && (userRoleManual?.length === 0 || projectAdminRoles.some(item => userRoleManual?.includes?.(item))))

  //   );
  //   //console.log("button sts", sts)
  //   return sts;
  // };

  const btn_sts = (
    expectedCompany,
    projectAdminRoles = []
  ) => {
    var sts = (      
      // ((getUserCompanyDetails === expectedCompany && proj_access_level === true) || projectAdminRoles.some(item => userRoleManual?.includes?.(item)))
      projectAdminRoles.some(item => userRoleManual?.includes?.(item))
    );
    return sts;
  };
      
    return (
        <div id="sync-to-acc" className="bodywrap">
          {loading && <FullscreenLoader />} 
   <div className="header">
   <div className={`headerWrapper clearfix ${ wbsColumns.length < 4 ? "header-div1" : "header-div2"}`} >
    <div className="leftWrap">
        <p className="notice">Please review PIF before submitting.</p>
    </div>
        <div className="rightWrap">
        <button
            id="submit"
            disabled=   
            {
              !( 
                exportLoading === false && (btn_sts("NUS",['Admin & Contract (AC)']))
                // (
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin & Contract (AC)') 
                //   // (userRoleManual === 'Admin & Contract (AC)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                // )
              )
            }
            onClick={exportToXLS}
            style={{
              padding: '10px 20px !important',
              backgroundColor: 
                // (
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin & Contract (AC)') 
                //   // (userRoleManual === 'Admin & Contract (AC)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                // ) 
                (btn_sts("NUS",['Admin & Contract (AC)'])) ? '' : 'grey'
            }}
          >
            {exportLoading ? 'Loading...' : 'Submit'}
          </button>

          <button
                id="export_xlsx"
                // disabled={!csvexportLoading && getUserAccess === 'project_admin' ? false : true}
                //  exportToExcel() exportData('xlsx')
                onClick={() => handleExport() } 
                style={{  padding: '10px 20px !important', margin: '0 0 0 10px !important', backgroundColor: '#003D7C' }}
            >
                {csvexportLoading ? 'Loading...' : 'Export to Excel'}
            </button>

            <button
                id="export_csv"
                // disabled={!csvexportLoading && getUserAccess === 'project_admin' ? false : true}
                onClick={() => exportData('csv')} 
                style={{  padding: '10px 20px !important', margin: '0 0 0 10px !important', backgroundColor: '#003D7C' }}
            >
                {csvexportLoading ? 'Loading...' : 'Export to CSV'}
            </button>
            <PrintButton projectName={projectName} />
        </div>
      </div>
      </div>
            <div className={`${ wbsColumns.length < 4 ? "main-div2" : "main-div1"} tablewrap`}  id="export-section" style={{ overflowY: 'auto', border: '1px solid #ddd',height: 'calc(100vh - 225px) !important' }}>
                <table id="wbsTable">
                    <thead>
                        <tr>
                            <th className="description-column" style={{ width:  "410px" }}>WBS No</th>
                            {wbsColumns.map((wbsId, index) => (
                                <th key={index}>{wbsId}</th>
                            ))}
                            <th className="description-column">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                    {rows.length === 0 ? (
                        <tr>
                            <td colSpan={wbsColumns.length + 2} style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>{WBSTableLoading ? 'Loading...' : 'No records found'}</td>
                        </tr>
                        ) : (
                            rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td className={rowIndex > 1 ? "undescription-column-2":"undescription-column"}>{row.description}</td>
                                    {row.data.map((item, itemIndex) => (
                                        <td key={item.id} className={rowIndex > 1 ? "undescription-column-2":"undescription-column"}>
                                            {/* {item.value} */}
                                            {(rowIndex==2) ?formatCurrency(item.value): item.value  }

                                        </td>
                                    ))}
                                    
               {rowIndex !== 1 && <td rowSpan={rowIndex == 0 ? 2 : 0} className={rowIndex > 1 ? "undescription-column-2":"undescription-column"}>{rowIndex < 2 ? "" : formatCurrency(row.total)}</td>}
                                    {/* <td className="total-column">{rowIndex < 2 ? "" : formatCurrency(parseFloat(row.total).toFixed(2))}</td> */}
                                </tr>
                            ))
                        )}

                    </tbody>
                </table>
                <br />
            <div className="table-container" >
              {/* ref={tableRef}  */}
                <table id="costTable"  style={{ width: '100%' }} className="costTable">
                    <thead>
                        <tr>
                            <th colSpan="2" id="description-wbs">Description</th>
                            <th id="contract-wbs">Contract Sum</th>
                            {wbsColumns.map((wbsId, index) => (
                                <th key={`wbs-${index}`}>{wbsId}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                    {(addedItems.length === 0 || WBSTableLoading || WBSEditTableLoading) ? (
                        <tr>
                            <td colSpan={wbsColumns.length + 4} style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>{(WBSTableLoading || WBSEditTableLoading) ? 'Loading...' : 'No records found'}</td>
                        </tr>
                        ) : (
                          
                        addedItems.map((group, groupIndex) => {
                            // Calculate total for the group
                            const groupTotalValue =  group.descriptions.reduce((groupAcc, descriptionObj) => {
                                const rowTotal = Object.values(descriptionObj.wbsValues || {}).reduce(
                                    (rowAcc, value) => parseFloat(rowAcc) + parseFloat(value),
                                    0
                                );
                                return parseFloat(groupAcc) + parseFloat(rowTotal);
                            }, 0);

                            return (
                                <React.Fragment key={`group-${groupIndex}`}>
                                    {/* Group Row */}
                                    <tr style={{ backgroundColor: '#e6f0ff' }}>
                                        <td colSpan="2" style={{ fontWeight: 'bold' }}>{group.group}</td>
                                        <td></td>
                                        {wbsColumns.map((wbsId, columnIndex) => {
                                            const columnTotal = group.descriptions.reduce(
                                                (acc, descriptionObj) => acc + parseFloat(descriptionObj.wbsValues?.[wbsId] || 0),
                                                0
                                            );
                                            return <td key={`group-total-${columnIndex}`}>{formatCurrency(columnTotal.toFixed(2))}</td>;
                                        })}
                                        <td>{ formatCurrency(groupTotalValue)}</td>
                                        
                                    </tr>

                                    {/* Description Rows */}
                                    {group.descriptions.map((descriptionObj, descIndex) => {
                                        const rowTotalValue = Object.values(descriptionObj.wbsValues || {}).reduce(
                                            (acc, value) => acc + parseFloat(value),
                                            0
                                        );
                                        return (
                                            <tr className="data-row" key={`desc-${descIndex}`}>
                                                <td>{descIndex + 1}</td>
                                                <td>{descriptionObj.description}</td>
                                                <td>from LOA</td>
                                                
                                                {/* {wbsColumns.map((wbsId, columnIndex) => (
                                                    <td key={`cost-${groupIndex}-${columnIndex}`}>
                                                      {descriptionObj.wbsValues?.[wbsId] ? '$' :''}
                                                        &nbsp;<input
                                                            readOnly
                                                            type="number"
                                                            value={ descriptionObj.wbsValues?.[wbsId] || ''}
                                                        />
                                                    </td>
                                                ))} */}
                                                
                                                {wbsColumns.map((wbsId, columnIndex) => (
                                                  <td key={`cost-${groupIndex}-${columnIndex}`}>
                                                    {descriptionObj.wbsValues?.[wbsId] ? '$' : ''}
                                                    &nbsp;{formatAsCurrency(descriptionObj.wbsValues?.[wbsId] || '')}
                                                    {/* <input
                                                      className="currenct-input" 
                                                      readOnly
                                                      type="text" // Changed to text to avoid number-specific input behavior
                                                      value={formatAsCurrency(descriptionObj.wbsValues?.[wbsId] || '')} 
                                                    /> */}
                                                  </td>
                                                ))} 
                                                <td>{formatCurrency(rowTotalValue.toFixed(2))}</td>
                                            </tr>
                                        );
                                    })}
                                </React.Fragment>
                            );
                        })
                        )}
                      </tbody>
                        {!WBSEditTableLoading && (
                        <>
                        <tfoot>
                        {/* GST Calculation Row */}
                        <tr style={{ backgroundColor: '#e6f0ff' }}>
                            <td colSpan="2">GST (on all items above excluding GST Adjustments, if any)</td>
                            <td></td>
                            {wbsColumns.map((_, columnIndex) => {
                                const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                                    return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                                        return descAcc + parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]] || 0);
                                    }, 0);
                                }, 0);
                                const ninePercentValue = (allGroupTotalValue * 0.09).toFixed(2);
                                return <td key={`gst-${columnIndex}`}>{formatCurrency(ninePercentValue)}</td>;
                            })}
                            <td>
                                {formatCurrency(wbsColumns.reduce((total, _, columnIndex) => {
                                    const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                                        return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                                            return descAcc + parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]] || 0);
                                        }, 0);
                                    }, 0);
                                    return total + allGroupTotalValue * 0.09;
                                }, 0).toFixed(2))}
                            </td>
                        </tr>

                        {/* Total Project Cost Row */}
                        <tr style={{ backgroundColor: '#e6f0ff' }}>
                            <td colSpan="2">Total Project Cost</td>
                            <td></td>
                            {wbsColumns.map((_, columnIndex) => {
                                const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                                    return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                                        return descAcc + parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]] || 0);
                                    }, 0);
                                }, 0);
                                const ninePercentValue = allGroupTotalValue * 0.09;
                                const totalProjectCost = allGroupTotalValue + ninePercentValue;
                                return <td key={`total-cost-${columnIndex}`}>{formatCurrency(totalProjectCost.toFixed(2))}</td>;
                            })}
                            <td>
                                {formatCurrency( wbsColumns.reduce((total, _, columnIndex) => {
                                    const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                                        return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                                            return descAcc + parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]] || 0);
                                        }, 0);
                                    }, 0);
                                    const ninePercentValue = allGroupTotalValue * 0.09;
                                    return total + allGroupTotalValue + ninePercentValue;
                                }, 0).toFixed(2))}
                            </td>
                        </tr>

                        {/* Type 1 Savings Row */}
                        <tr style={{ backgroundColor: '#e6f0ff' }}>
                          <td colSpan="2">Type 1 Savings (to declare for savings of $50k and above)</td>
                          <td></td>
                          {wbsColumns.map((_, columnIndex) => {
                            // Step 1: Calculate the Approved Budget for the current column (from first table)
                            const approvedBudget = rows.reduce((acc, row) => {
                              const itemValue = row.data[columnIndex]?.value; // Get value for the current column
                              // Add the value if it's valid (ensure it's a valid number)
                              if (!isNaN(itemValue)) { // Debugging line
                                return  parseFloat(itemValue);
                              }
                              return acc;
                            }, 0);
                            const totalProjectCost = addedItems.reduce((groupAcc, group) => {
                              return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                                // Retrieve the value for the current column from wbsValues
                                const value = parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]]) || 0;
                                return descAcc + value;
                              }, 0);
                            }, 0);
                            const gst = totalProjectCost * 0.09;
                            const totalProjectCostWithGST = totalProjectCost + gst;
                            const savings = approvedBudget - totalProjectCostWithGST;
                            return (
                              <td key={`type-1-savings-${columnIndex}`}>
                                {isNaN(savings) || savings === 0 ? '$0.00' : formatCurrency(savings.toFixed(2))}
                              </td>
                            );
                          })}
                          {/* Grand Total Savings (for all columns) */}
                          <td>
                            {formatCurrency(wbsColumns.reduce((total, _, columnIndex) => {
                              const approvedBudget = rows.reduce((acc, row) => {
                                const itemValue = row.data[columnIndex]?.value;
                                if (!isNaN(itemValue)) {
                                  return parseFloat(itemValue);
                                }
                                return acc;
                              }, 0);
                              const totalProjectCost = addedItems.reduce((groupAcc, group) => {
                                return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                                  const value = parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]]) || 0;
                                  return descAcc + value;
                                }, 0);
                              }, 0);
                              const gst = totalProjectCost * 0.09;
                              const totalProjectCostWithGST = totalProjectCost + gst;

                              const savings = approvedBudget - totalProjectCostWithGST;
                              // console.log('Savings:', savings, 'Approved Budget:', approvedBudget, 'Total Project Cost with GST:', totalProjectCostWithGST);
                              return total + (isNaN(savings) ? 0 : savings);
                            }, 0).toFixed(2))}
                          </td>
                        </tr>
                        {/* Interim Type 3 Row */}
                        <tr style={{ backgroundColor: '#e6f0ff' }}>
                            <td colSpan="2">Interim Type 3</td>
                            <td></td>
                            {wbsColumns.map((_, columnIndex) => (
                                <td key={`interim-type-3-${columnIndex}`}>0</td>
                            ))}
                            <td>0</td>
                        </tr>
                        </tfoot>
                        </>
                        )}
                </table>
              </div>
            </div>
        </div>
    );
}

export default Wbs2iframesync;
